import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.5
    }
  };
  return <section id="oferta" className="w-full bg-white py-16 md:py-24 px-4" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <motion.div {...fadeInUp} className="text-center mb-12" data-id="element-90">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] mb-4" data-id="element-91">
            Obtén El Plan 0-Down para Inquilinos hoy mismo
          </h2>
          <p className="text-lg text-gray-600" data-id="element-92">
            Deja de financiar el retiro de tu dueño de casa y empieza a
            construir el tuyo.
          </p>
        </motion.div>

        <motion.div {...fadeInUp} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-gradient-to-br from-[#F9F6F1] to-white border-2 border-[#D4A843] rounded-3xl p-8 md:p-12 text-center shadow-xl" data-id="element-93">
          {/* Product Image */}
          <div className="mb-8" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/mt5RVSnf14YJoJHiPmdSMg/El_Plan_0_Down_Dilore_Publishing.png" alt="El Plan 0-Down para Inquilinos" className="w-48 md:w-64 mx-auto drop-shadow-lg" data-id="element-95" />
          </div>

          {/* Price */}
          <div className="mb-8" data-id="element-96">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-97">
              <span className="text-2xl text-gray-400 line-through" data-id="element-98">$27</span>
              <span className="text-5xl md:text-6xl font-extrabold text-[#D4A843]" data-id="element-99">
                $6.39
              </span>
            </div>
            <p className="text-gray-600 font-medium" data-id="element-100">Pago único</p>
          </div>

          {/* CTA Button */}
          <motion.a href="https://rutapatrimonio.com/cart/53761946878262:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'El Plan 0-Down para Inquilinos',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
        }} className="inline-block bg-[#D4A843] text-[#0F2440] font-bold text-lg md:text-xl px-10 py-5 rounded-xl shadow-lg shadow-[#D4A843]/30 mb-6" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 17
        }} data-id="element-101">
            ¡QUIERO MI PLAN 0-DOWN AHORA!
          </motion.a>

          {/* Trust Indicators */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-gray-500 text-sm" data-id="element-102">
            <div className="flex items-center gap-2" data-id="element-103">
              <LockIcon className="w-4 h-4" data-id="element-104" />
              <span data-id="element-105">Acceso inmediato tras la compra</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-106">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-107" />
              <span data-id="element-108">Tu información está 100% segura</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}